import {XMarkIcon} from "@heroicons/react/24/solid";
import React, {useState} from "react";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";


const ProductBlogPostMeta = ({blogPostContent}) => {

    return (
        <>
            {blogPostContent?.metaLines?.map((metaLine, metaLineIndex) => (
                <div key={`metaLine-${metaLineIndex}`}>
                    <div
                        className={`w-full mb-3 p-4 border border-gray-400 bg-white shadow-lg rounded-xl`}>

                        <div className={'flex items-center justify-between'}>
                            <div className={`w-full`}>
                                {metaLine?.isMeta &&
                                    <div
                                        className={`flex justify-between items-center font-bold text-sky-500`}>
                                        <div className={''}>{metaLine.metaLabel}</div>
                                        <CopyDataToClipboard
                                            sizeClass={'px-1 py-1'}
                                            value={metaLine?.text}/>
                                    </div>
                                }
                                <div
                                    className={`mt-2 flex justify-start text-gray-900 ${metaLine.isSection ? 'font-bold text-pink-500' : ''}`}>
                                    <div className={''}>{metaLine.text}</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            ))}
        </>
    )
}

export default ProductBlogPostMeta
